import router from "@/router";

const state = {
    reloadFlag: false,
    needUpdateCode: new Set(),

    //current Page
    checkedIdList: {},
    currentRows: {},
    checkChangeFlag: false,
};
const getters = {};
const actions = {
    clear(context, code) {
        context.commit('setCheckedIds', {
            code: code,
            ids: []
        });
        // context.commit('setCurrentRows', {
        //     code: code,
        //     rows: []
        // });
    },
    routeTo(context, code) {
        router.push({
            path: '/query/view/' + code
        })
    }
};
const mutations = {
    setNeed(state, code) {
        state.needUpdateCode.add(code);
        state.reloadFlag = !state.reloadFlag;
    },
    finish(state, code) {
        state.needUpdateCode.delete(code);
    },
    setCheckedIds(state, {code, ids}) {
        state.checkedIdList[code] = ids;
        state.checkChangeFlag = !state.checkChangeFlag;
    },
    setCurrentRows(state, {code, rows}) {
        state.currentRows[code] = rows;
        state.checkChangeFlag = !state.checkChangeFlag;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
